(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ritual-selector"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initRitualSelector(sectionId) {
      var root = document.getElementById('ritual-selector-' + sectionId);
      if (!root) return;

      var triggers = root.querySelectorAll('[data-scent-trigger]');
      var panels   = root.querySelectorAll('[data-scent-panel]');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          activateScent(trigger.dataset.scentTrigger);
        });
        trigger.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateScent(trigger.dataset.scentTrigger);
          }
        });
      });

      root.querySelectorAll('[data-add-ritual]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          handleAddToCart(btn);
        });
      });

      setTimeout(function() { updateSubtotal(); }, 80);

      function activateScent(id) {
        triggers.forEach(function(t) {
          var active = t.dataset.scentTrigger === id;
          t.classList.toggle('ritual-selector__scent--active', active);
          t.setAttribute('aria-checked', active ? 'true' : 'false');
          t.setAttribute('tabindex', active ? '0' : '-1');
        });

        panels.forEach(function(panel) {
          var active = panel.dataset.scentPanel === id;
          panel.classList.toggle('ritual-selector__panel--active', active);
          panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        updateSubtotal();
      }

      function getPriceText(card) {
        var priceEl = card.querySelector('sale-price') || card.querySelector('regular-price');
        if (!priceEl) return null;
        var textNode = Array.from(priceEl.childNodes).find(function(node) {
          return node.nodeType === 3 && node.textContent.trim().length > 0;
        });
        return textNode ? textNode.textContent.trim() : null;
      }

      function parsePrice(priceText) {
        var numericStr = priceText.replace(/[^0-9.,]/g, '');
        if (numericStr.indexOf(',') > -1 && numericStr.indexOf('.') > -1) {
          if (numericStr.indexOf('.') < numericStr.indexOf(',')) {
            return parseFloat(numericStr.replace(/\./g, '').replace(',', '.'));
          } else {
            return parseFloat(numericStr.replace(/,/g, ''));
          }
        } else if (numericStr.indexOf(',') > -1) {
          var commaPos = numericStr.indexOf(',');
          if (numericStr.length - commaPos === 3) {
            return parseFloat(numericStr.replace(',', '.'));
          } else {
            return parseFloat(numericStr.replace(',', ''));
          }
        }
        return parseFloat(numericStr);
      }

      function updateSubtotal() {
        var activePanel = root.querySelector('.ritual-selector__panel--active');
        if (!activePanel) return;
        var subtotalEl = activePanel.querySelector('[data-subtotal]');
        if (!subtotalEl) return;

        var total = 0;
        var samplePrice = '';

        activePanel.querySelectorAll('.ritual-selector__product-wrap').forEach(function(card) {
          var priceText = getPriceText(card);
          if (!priceText) return;
          if (!samplePrice) samplePrice = priceText;
          var amount = parsePrice(priceText);
          if (!isNaN(amount)) total += amount;
        });

        if (!samplePrice || total === 0) {
          subtotalEl.textContent = '';
          return;
        }

        var currencySymbol = samplePrice.replace(/[\s0-9.,]+/g, '').trim();
        var isSymbolBefore = samplePrice.indexOf(currencySymbol) < samplePrice.search(/[0-9]/);
        var formatted = (total % 1 === 0) ? total.toFixed(0) : total.toFixed(2);

        subtotalEl.textContent = isSymbolBefore
          ? currencySymbol + formatted
          : formatted + ' ' + currencySymbol;
      }

      async function handleAddToCart(btn) {
        var activePanel = root.querySelector('.ritual-selector__panel--active');
        if (!activePanel) return;
        var wraps = activePanel.querySelectorAll('.ritual-selector__product-wrap');
        if (!wraps.length) return;
        var items = Array.from(wraps).map(function(card) {
          return { id: parseInt(card.dataset.variantId, 10), quantity: 1 };
        });
        var originalLabel = btn.textContent.trim();
        btn.disabled = true;
        btn.textContent = 'Adding\u2026';
        try {
          var response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!response.ok) throw new Error('Cart error');
          btn.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:open'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function() {
            btn.textContent = originalLabel;
            btn.disabled = false;
          }, 2500);
        } catch(err) {
          console.error('Ritual selector:', err);
          btn.textContent = 'Something went wrong \u2014 try again';
          btn.disabled = false;
          setTimeout(function() { btn.textContent = originalLabel; }, 3000);
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('[id^="ritual-selector-"]').forEach(function(el) {
          initRitualSelector(el.id.replace('ritual-selector-', ''));
        });
      });
    } else {
      document.querySelectorAll('[id^="ritual-selector-"]').forEach(function(el) {
        initRitualSelector(el.id.replace('ritual-selector-', ''));
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
